import SaveDialog from "designSystem/components/dialog/SaveDialog";
import { useLocalReactionStore } from "designSystem/hooks";
import { useLocale } from "designSystem/locale";
import { ControllerProps } from "csi/middleware/common";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { createRestoreFromShapeStore } from "./RestoreFromShapeService";
import { RestoreFromShapeStoreContext } from "./RestoreFromShapeStore";
import RestoreSettingsForm from "./RestoreSettingsForm";

export const RestoreFromShapeDialog: FunctionComponent<ControllerProps> = observer((props) => {
	const { actionController, onClose, onSave } = props;
	const loc = useLocale();
	const store = useLocalReactionStore(() => createRestoreFromShapeStore(actionController, loc, onSave));
	const { actionMessage, titleRes, save } = store || {};

	return (
		<>
			{store && (
				<RestoreFromShapeStoreContext.Provider value={store}>
					<SaveDialog
						actionMessage={actionMessage}
						onClose={onClose}
						onSave={save}
						open
						titleRes={titleRes}
						width={528}		
					>
						{{
							main: (
								<RestoreSettingsForm />
							),
						}}
					</SaveDialog>
				</RestoreFromShapeStoreContext.Provider>
			)}
		</>
	);
});

export default RestoreFromShapeDialog;
